export const ACCESS_REQUEST_SUBJECT = /^Solicitud de acceso de\s*/i;

export const formatDateTime = value => {
  if (!value) return '';
  try {
    return new Intl.DateTimeFormat('es-MX', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(new Date(value));
  } catch (error) {
    return value;
  }
};

export const resolveSupportError = error => {
  if (!error) return 'Ocurrio un error inesperado.';
  if (typeof error === 'string') return error;
  return (
    error?.data?.message ||
    error?.message ||
    error?.response?.data?.message ||
    'Ocurrio un error inesperado.'
  );
};

export const INITIAL_TICKET_FORM = {
  subject: '',
  description: '',
  category: 'general',
  ticketType: 'support',
  priority: 'medium',
};
